import React, { useState, useEffect } from 'react';
import './call-styles.scss';
import paceIcon from '../../images/pace.svg';
import clarityIcon from '../../images/clarity.svg';
import sentenceLengthIcon from '../../images/sentence_lenght.svg';
import fillerWordsIcon from '../../images/filter_words.svg';
import overallIcon from '../../images/overall.svg';
import { useTranslate } from '../../lib'

const CallStyles = ({ data }) => {
  const { t } = useTranslate();
  const [styleData, setStyleData] = useState({
    pace: { score: 0, wpm: 0, feedback: t('reports.style.noData') },
    clarity: { score: 0, percentage: 0, feedback: t('reports.style.noData') },
    sentence_length: { score: 0, average_words: 0, feedback: t('reports.style.noData') },
    filler_words: { score: 0, count: 0, feedback: t('reports.style.noData') },
    overall: { score: 0, feedback: t('reports.style.noData') }
  });

  useEffect(() => {
    if (data && data.style) {
      setStyleData(data.style);
    }
  }, [data]);

  const getScoreColor = (score) => {
    if (score >= 90) {
      return '#4CAF50';
    } else if (score >= 70) {
      return '#FFC107';
    } else {
      return '#F44336';
    }
  };

  return (
    <div className="call-styles-container">
      <div className="metrics-container">
        {/* OVERALL SECTION - Layout especial sin metric-left */}
        <div className="metric-card" style={{backgroundColor: "#eef7ff"}}>
          <div className="metric-header" style={{backgroundColor: "#eef7ff"}}>
            <div className="metric-icon">
                <img src={overallIcon} width="35" alt="Overall" />
            </div>
            <span className="metric-title">{t('reports.style.overall')}</span>
          </div>
          
          <div className="metric-content">
            <div className="metric-right">
              <div className="metric-label">{t('common.score')}</div>
              <div 
                className="metric-score-circle" 
                style={{ backgroundColor: getScoreColor(styleData?.overall?.score) }}
              >
                {styleData?.overall?.score || 0}
              </div>
            </div>
          </div>
          
          <div className="metric-feedback">
            <div className="metric-feedback-label">{t('reports.style.feedback')}</div>
            <div className="metric-feedback-value">{styleData?.overall?.feedback || t('reports.style.noData')}</div>
          </div>
        </div>

        {/* PACE SECTION */}
        <div className="metric-card">
          <div className="metric-header">
            <div className="metric-icon">
                <img src={paceIcon} width="35" alt="Pace" />
            </div>
            <span className="metric-title">{t('reports.style.pace')}</span>
          </div>
          
          <div className="metric-left">
            <div className="metric-label">{t('reports.style.wpm')}</div>
            <div className="metric-value">{styleData?.pace?.wpm || 0}</div>
          </div>
          
          <div className="metric-right">
            <div className="metric-label">{t('common.score')}</div>
            <div 
              className="metric-score-circle" 
              style={{ backgroundColor: getScoreColor(styleData?.pace?.score) }}
            >
              {styleData?.pace?.score || 0}
            </div>
          </div>
          
          <div className="metric-feedback">
            <div className="metric-feedback-label">{t('reports.style.feedback')}</div>
            <div className="metric-feedback-value">{styleData?.pace?.feedback || t('reports.style.noData')}</div>
          </div>
        </div>
        
        {/* CLARITY SECTION */}
        <div className="metric-card">
          <div className="metric-header">
            <div className="metric-icon">
                <img src={clarityIcon} width="35" alt="Clarity" />
            </div>
            <span className="metric-title">{t('reports.style.clarity')}</span>
          </div>
          
          <div className="metric-left">
            <div className="metric-label">{t('common.percentage')}</div>
            <div className="metric-value">{styleData?.clarity?.percentage || 0}%</div>
          </div>
          
          <div className="metric-right">
            <div className="metric-label">{t('common.score')}</div>
            <div 
              className="metric-score-circle" 
              style={{ backgroundColor: getScoreColor(styleData?.clarity?.score) }}
            >
              {styleData?.clarity?.score || 0}
            </div>
          </div>
          
          <div className="metric-feedback">
            <div className="metric-feedback-label">{t('reports.style.feedback')}</div>
            <div className="metric-feedback-value">{styleData?.clarity?.feedback || t('reports.style.noData')}</div>
          </div>
        </div>
        
        {/* SENTENCE LENGTH SECTION */}
        <div className="metric-card">
          <div className="metric-header">
            <div className="metric-icon">
                <img src={sentenceLengthIcon} width="35" alt="Sentence Length" />
            </div>
            <span className="metric-title">{t('reports.style.sentenceLength')}</span>
          </div>
          
          <div className="metric-left">
            <div className="metric-label">{t('reports.style.averageWords')}</div>
            <div className="metric-value">{styleData?.sentence_length?.average_words || 0}</div>
          </div>
          
          <div className="metric-right">
            <div className="metric-label">{t('common.score')}</div>
            <div 
              className="metric-score-circle" 
              style={{ backgroundColor: getScoreColor(styleData?.sentence_length?.score) }}
            >
              {styleData?.sentence_length?.score || 0}
            </div>
          </div>
          
          <div className="metric-feedback">
            <div className="metric-feedback-label">{t('reports.style.feedback')}</div>
            <div className="metric-feedback-value">{styleData?.sentence_length?.feedback || t('reports.style.noData')}</div>
          </div>
        </div>
        
        {/* FILLER WORDS SECTION */}
        <div className="metric-card">
          <div className="metric-header">
            <div className="metric-icon">
                <img src={fillerWordsIcon} width="35" alt="Filler Words" />
            </div>
            <span className="metric-title">{t('reports.style.fillerWords')}</span>
          </div>
          
          <div className="metric-left">
            <div className="metric-label">{t('reports.style.count')}</div>
            <div className="metric-value">{styleData?.filler_words?.count || 0}</div>
          </div>
          
          <div className="metric-right">
            <div className="metric-label">{t('common.score')}</div>
            <div 
              className="metric-score-circle" 
              style={{ backgroundColor: getScoreColor(styleData?.filler_words?.score) }}
            >
              {styleData?.filler_words?.score || 0}
            </div>
          </div>
          
          <div className="metric-feedback">
            <div className="metric-feedback-label">{t('reports.style.feedback')}</div>
            <div className="metric-feedback-value">{styleData?.filler_words?.feedback || t('reports.style.noData')}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallStyles;